import React, { useState, useEffect } from "react";
import { graphql } from "gatsby";
import "normalize.css";
import GlobalStyles from "../styles/GlobalStyles";
import styled, { css } from "styled-components";
import { dimensions } from "../styles/foundation";
import Helmet from "react-helmet";

const ScrollToTop = styled.button<{ scrollVisibility: boolean }>`
  display: none;
  position: fixed;
  background-color: #666;
  width: 70px;
  height: 70px;
  bottom: 60px;
  right: 60px;
  outline: 0;
  border: 0;
  cursor: pointer;
  z-index: 1;
  border-radius: 50%;
  ${({ scrollVisibility }) =>
    scrollVisibility
      ? css`
          visibility: visible;
          opacity: 1;
          transition: visibility 0s linear 0s, opacity 300ms;
        `
      : css`
          visibility: hidden;
          opacity: 0;
          transition: visibility 0s linear 300ms, opacity 300ms;
        `};
  &:after {
    content: " ";
    display: block;
    width: 12px;
    height: 12px;
    border-style: solid;
    border-width: 4px;
    border-color: transparent transparent #fff #fff;
    transform: rotate(135deg);
    margin: 10px auto 0 auto;
  }
  &:hover {
    opacity: 0.7;
  }
  @media (min-width: ${dimensions.breakPoint + 1}px) {
    display: block;
  }
`;

const handleClick = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

const Layout = ({ children }: { children: any }) => {
  // Scroll to topのcssを制御
  const [scrollVisibility, setScrollVisibility] = useState(false);

  // Scroll to topのstateを変更する
  useEffect(() => {
    let toggle = false;
    const onScroll = () => {
      const position = window.pageYOffset;
      if (position > 500 && !toggle) {
        toggle = true;
        setScrollVisibility(true);
        console.log(toggle);
      } else if (position <= 500 && toggle) {
        toggle = false;
        setScrollVisibility(false);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      <Helmet>
        <html lang="ja" />
      </Helmet>
      <GlobalStyles />
      {children}
      <ScrollToTop onClick={handleClick} scrollVisibility={scrollVisibility} aria-label="最上部に移動するボタン" />
    </>
  );
};

export default Layout;
